import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { PopoverController } from '@ionic/angular';
import { OpcionesExportarComponent } from 'src/app/componentes/opciones-exportar/opciones-exportar.component';


@Component({
  selector: 'app-compra-utiles',
  templateUrl: './compra-utiles.component.html',
  styleUrls: ['./compra-utiles.component.scss'],
})
export class CompraUtilesComponent implements OnInit {

  @Output() correo = new EventEmitter();
  @Output() desabilitar = new EventEmitter();
  disabled: boolean=true;

  constructor( private conexion: ConexionService, private utilidades: UtilidadesService,
    private popoverController: PopoverController) { }

  Fecha = {Fecha1: "", Fecha2: ""}
    
    @Input() UserID =""

  @ViewChild('pdfTable') pdfTable: ElementRef;
  pdf:string=""

  Documentos = []
 Datos(v:Array<any>){
    if(v.length>0){
      setTimeout(() => {
        this.Documentos = v
      }, 100);
    }
  }
  

  async Exportar(e: Event) {
    const popover = await this.popoverController.create({
      component: OpcionesExportarComponent,
      event: e,
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();

    this.utilidades.Depuracion(data, "console", "")

    if (data == "pdf") {
      this.pdfF()
    } else if (data == "excel") {
      this.exportexcel()
    }
  }


  ngOnInit() {
    setTimeout(() => {
      this.HayDatos()
    }, 10000);
  setTimeout(() => {
    this.getCompraUtiles()
  }, 100);
   }

  Sumar(array, key): number {
    let total: number = 0
    for (let i of array) {
      total += Number(i[key])
    }
    return total
  }


  Total(){
    let total = 0;
    for(let i of this.Documentos){
      total+=this.Sumar(i.Datos, "Importe")
    }

    return total
  }

  Imprimir() {

    let vent = window.open('', '', 'height=800, width=800');
    vent.document.write(this.TextoMostrable())
    vent.document.close()
    setTimeout(() => {
      vent.print()
    }, 300);

  }

  TextoMostrable() {
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title> </title> <style> *{font-family: "Arial", sans-serif !important;} .divTablaExport{max-width: 1024px; min-width: 260px;} body{margin: 0;} .h3{margin: 20px 2px 2px 2px; font-size: 14px !important; font-weight: 800 !important;} th{ padding:  6px 0; font-size: 11px !important;} table { border-collapse: separate; width: 100%; table-layout: fixed; } .table_header th { border-top: 1px solid black; border-bottom: 1px solid black; font-size: 12px;} .table_header th:last-child { border-right: 1px solid black; border-top-right-radius: 5px; border-bottom-right-radius: 5px; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px; border-bottom-left-radius: 5px; } td{ text-align: left; font-size: 13px;}  .thImp, .thImpF{padding: 6px 0; font-size: 11px !important; text-align: center; width: 95px !important;} .thImpC{padding: 6px 0; font-size: 11px !important; text-align: center; width: 220px !important;} .thImpS{padding: 6px 0; font-size: 11px !important; text-align: center; width: 60px !important;} .thImp2, .thImpF2{padding: 0 !important; margin: 0; font-size: 0px !important; color:transparent; text-align: center; width: 95px !important; height: 1px;} .thImpS2, .thImpSL2{padding: 0 !important; margin: 0; font-size: 0px !important; color:transparent; text-align: center; width: 60px !important; height: 1px;} .thImpC2{padding: 0 !important; margin: 0; font-size: 0px !important; color:transparent;  text-align: center; width: 220px !important; height: 1px;} .tdImp, .tdImpF{ text-align: left; font-size: 13px; width: 95px !important;} .tdImpC{ text-align: left; font-size: 12px; width: 220px !important;} .tdImpS, .tdImpSL{ text-align: right; font-size: 13px; width: 60px !important;} .tdImpR{ text-align: right; font-size: 13px; width: 95px !important;} .tdImpSL{ text-align: left !important; padding-left: 4px;} .tdcantdocs{ padding: 5px 0; border-bottom: 1px solid black; border-top: 1px solid black; text-align: center; font-size: 11px;} .tdEstudianteF{font-size: 13px !important;}  .thImpF2, .thImpF, .tdImpF{width: 75px !important;}  </style> </head> <body> <div style="text-align: center; font-family: "Arial", sans-serif;"><h3 class="h3"> INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </h3> <p style="font-size: 12px; margin: 3px 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 15px; margin: 13px 0 5px 0;"> <b> Reporte de compra de útiles y servicios </b> </p> <p style="font-size: 12px; margin: 2px 0 15px 0;"> <b>Incluye Docs. Desde:</b> {{FechaDesde}}  <b>Hasta:</b>{{FechaHasta}} </p>  </div> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML)
  }
  

  TextoMostrablePDF() {
    return '<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta http-equiv="X-UA-Compatible" content="IE=edge"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title> </title> <style> *{font-family: "Arial", sans-serif !important;} .divTablaExport{max-width: 1024px; min-width: 260px;} body{margin: 0;} .h3{margin: 20px 2px 2px 2px; font-size: 11px !important; font-weight: 800 !important;} th{ padding:  6px 0; font-size: 8px !important;} table { border-collapse: separate; width: 100%; table-layout: fixed; } .table_header th { border-top: 1px solid black; border-bottom: 1px solid black;} .table_header th:last-child { border-right: 1px solid black; border-top-right-radius: 5px !important; border-bottom-right-radius: 5px !important; } .table_header th:first-child { border-left: 1px solid black; border-top-left-radius: 5px !important; border-bottom-left-radius: 5px !important; } td{ text-align: left; font-size: 9px !important;}  .thImp, .thImpF{padding: 6px 0; font-size: 8px !important; text-align: center; width: 65px !important;} .thImpC{padding: 6px 0; font-size: 8px !important; text-align: center; width: 150px !important;} .thImpS{padding: 6px 0; font-size: 8px !important; text-align: center; width: 55px !important;} .thImp2, .thImpF2{padding: 0 !important; margin: 0; font-size: 0px !important; color:transparent; text-align: center; width: 65px !important; height: 1px;} .thImpS2, .thImpSL2{padding: 0 !important; margin: 0; font-size: 0px !important; color:transparent; text-align: center; width: 35px !important; height: 1px;} .thImpS2{ width: 28px !important;} .thImpC2{padding: 0 !important; margin: 0; font-size: 0px !important; color:transparent;  text-align: center; width: 163px !important; height: 1px;} .tdImp, .tdImpF{ text-align: left !important; font-size: 9px !important; width: 65px !important;} .tdImpC{ text-align: left !important; font-size: 8px !important; width: 163px !important;} .tdImpS{ text-align: right !important; font-size: 9px !important; width: 28px !important;} .tdImpR{ text-align: right !important; font-size: 9px !important; width: 68px !important;} .tdImpSL{ text-align: left !important; padding-left: 4px; width: 35px !important;} .tdcantdocs{ padding: 5px 0; border-bottom: .5px solid black; border-top: .5px solid black; text-align: center; font-size: 8px;} .tdEstudianteF{font-size: 9px !important;}  .thImpF2, .thImpF, .tdImpF{width: 48px !important;}  </style> </head> <body> <div style="text-align: center; font-family: "Arial", sans-serif;"><h3 class="h3"> INSTITUTO DE DESARROLLO INTEGRAL LEONARDO DA VINCI </h3> <p style="font-size: 9px; margin: 1px;"> "SEA NUESTRO AVAL EL RECTO PENSAR" </p> <p style="font-size: 10px; margin: 13px 0 5px 0;"> <b> Reporte de compra de útiles y servicios </b> </p> <p style="font-size: 9px; margin: 2px 0 15px 0;"> <b>Incluye Docs. Desde:</b> {{FechaDesde}}  <b>Hasta:</b>{{FechaHasta}} </p>  </div> {{Hola}} </body> </html>'.
      replace("{{Hola}}", document.getElementById("todo").innerHTML)
  }

  exp = "TablaExportar"
  excel=false
  exportexcel(): void {
    this.exp = ""
      this.excel=true
    this.utilidades.Toast("Descargando Excel...", 3000, "download-outline")
    setTimeout(() => {
      /* table id is passed over here */
      const downloadLink = document.createElement("a");
      const dataType = 'application/vnd.ms-excel';
      const table = document.getElementById("datos");
      const tableHtml = table.outerText.replace(/ /g, '%20')
      document.body.appendChild(downloadLink);
      downloadLink.href = 'data:' + dataType + ' ' + tableHtml;
      downloadLink.download = "Compra de utiles " + String(new Date()) + ".xls";
      downloadLink.click();

      this.exp = "TablaExportar"
      this.excel=false
    }, 150);
  }

  pdfF(){
    this.utilidades.Toast("Descargando PDF...", 3000, "download-outline")
    let d = document.getElementById("imprimible")
    d.innerHTML = this.TextoMostrablePDF()
    this.pdf="pedefeable"
    document.getElementById("cc").scrollTo({ top: 0, behavior: "smooth" })
    setTimeout(() => {
      let pd = new jspdf('p', 'pt', 'a4')
    pd.html(this.pdfTable.nativeElement,{"margin":[25, 0, 25, 0], callback: (pdf) =>{
      pdf.save("Compra de utiles " + String(new Date()) +".pdf")
      setTimeout(() => {
        d.innerHTML = ""
        this.pdf = ""
      }, 800);
    }})
    }, 100);
    
  }


  getCompraUtiles() {
    this.utilidades.Loading("Cargando documentos")
    this.conexion.getCompraUtiles(this.UserID,
      this.Fecha.Fecha1, this.Fecha.Fecha2).subscribe((resp) => {
        this.desabilitar.emit(false)
        this.disabled=false;
        this.utilidades.CerrarLoading()
        this.utilidades.Depuracion(resp, "console", "")
        if (resp.Respuesta == "Exito") {
          this.Datos(resp.Datos)
          this.utilidades.Depuracion(resp.Datos, "console", "")
        }
      }, (err) => {
        this.utilidades.CerrarLoading()
        this.utilidades.Alerta("En estos momentos este servicio no se encuentra disponible. Por favor, inténtelo más tarde.")
        this.desabilitar.emit(true)
        this.disabled=true;
        this.utilidades.ValidarUser(err)
      })
  }


  HayDatos(): boolean {
    if (document.getElementById("datos")) {
      if (document.getElementById("datos").innerText.length > 90) {
        return true;
      }
    }
    return false;
  }
}
